/**
 * External Dependencies.
 */

import "babel-polyfill";
import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import {
	get,
	assign,
	cloneDeep,
	merge,
	isString
} from 'lodash';

/**
 * Internal Dependencies.
 */
import App from './App.vue';
import router from './router';
import store from './store';

Vue.filter('assetUrl', (value) => {
	return `${crb_app.theme_url}${value}`
});



window.CabinsBooking = {
	async init() {
		try {
			const data = await jQuery.ajax( {
				url: crb_app.ajax_url,
				data: {
					action: 'crb_get_data_from_cache'
				}
			} )

			if ( crb_booking_app.load_session_data ) {
				store.replaceState(merge(
					cloneDeep(store.state),
					{
						product: {
							product: crb_booking_app.session_data,
							steps: {
								overview: true,
								passengers: true,
								deck: true,
								cabin: true,
								order: true,
							},
						},
					}
				));
			}

			return new Vue({
				router,
				store,
				render: h => h(App),
				mounted() {
					this.$store.dispatch( 'setDecks', data );

					if ( crb_booking_app.load_session_data ) {
						if ( crb_booking_app.session_data ) {
							setTimeout(() => {
								this.$router.push({name:'cruise.order'})
							}, 500);
						}
					}
				}
			}).$mount(document.querySelector('#app'));
		} catch(e) {
			console.error(e)
		}
	}
}

CabinsBooking.init();


// WEBPACK FOOTER //
// ./src/main.js